<script>
import ModalCloseButton from '@phoenix/mixins/components/common/ModalCloseButton';
import { PhxIcon } from '@phx-styleguides/pia';

export default {
  components: { PhxIcon },

  mixins: [ModalCloseButton],
};
</script>

<template>
  <button
    class="btn btn--bare btn--fade btn--xs btn--icon-only modal__close-button"
    type="button"
    data-cy="modal-close-button"
    @click="closeModal(modalId)"
  >
    <span class="btn__icon btn__icon--start">
      <phx-icon icon="close" class="icon icon--close icon--xs" :title="$t('Accessibility.modal.close')" />
    </span>
  </button>
</template>
